import { throttle } from '@/core';
import {
	getTripTemplatesRequest,
	newTripTemplateRequest,
	updateTripTemplateRequest,
	deleteTripTemplateRequest,
	getGeneratedTripsRequest
} from '../requests';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

import frequencySetters from './setters/frequencySetters.actions';
import tripSetters from './setters/tripSetters.actions';
import legSetters from './setters/legSetters.actions';

async function getTripTemplates({ state, commit }, refresh = false) {
	commit('set', { path: 'loading', value: true });
	try {
		if (state.tripTemplates.length === 0 || refresh) {
			await fetchTripTemplates();
		} else {
			await throttle(fetchTripTemplates, 'fetchTripTemplates', 60 * 1000);
		}
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', { path: 'loading', value: false });

	async function fetchTripTemplates() {
		let response = await getTripTemplatesRequest();
		commit('setTripTemplates', response);
	}
}

async function deleteTemplates({ state, commit }, templateIds) {
	try {
		for (let templateId of templateIds) {
			await deleteTripTemplateRequest(templateId);
		}
		let updatedTemplates = state.tripTemplates.filter(template => templateIds.indexOf(template.id) < 0);
		commit('setTripTemplates', updatedTemplates);
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function saveTripTemplate({ state, commit, dispatch }) {
	await dispatch('validateAll');
	if (state.errors.isInvalid) {
		throw new Error('validationErrors');
	}

	let newTripTemplate = deepCopy(state.templateDetails);
	let oldTripTemplate = state.tripTemplates.find(x => x.id === newTripTemplate.id);

	if (oldTripTemplate) {
		try {
			let patch = rdbClient.createPatch(oldTripTemplate, newTripTemplate);
			if (!patch.length) {
				commit('set', { path: 'dirty', value: false });
				return true; // allreadyUpToDate
			}
			await updateTripTemplateRequest(newTripTemplate.id, { patch });
			let updatedTripTemplates = [...state.tripTemplates];
			updatedTripTemplates[updatedTripTemplates.indexOf(oldTripTemplate)] = newTripTemplate;
			commit('setTripTemplates', updatedTripTemplates);
		} catch (err) {
			throw new Error('failedToUpdate');
		}
	} else {
		try {
			let response = await newTripTemplateRequest(newTripTemplate);
			newTripTemplate.id = response.id;
			commit('setTripTemplates', [ ...state.tripTemplates, newTripTemplate ]);
		} catch (err) {
			throw new Error('failedToCreate');
		}
	}
	commit('set', { path: 'dirty', value: false });
	return false;
}

async function fetchGeneratedTrips({ state, dispatch }) {
	try {
		let generatedTrips = await getGeneratedTripsRequest(state.templateDetails.generatedTrips);
		dispatch('setGeneratedTrips', generatedTrips);
	} catch (err) {
		throw new Error('failedToFetch');
	}
}

function setGeneratedTrips({ commit, dispatch }, trips) {
	commit('setGeneratedTrips', trips);
	dispatch('findNextTrip');
}

function setOrderTemplateBindings({ commit }, value) {
	commit('setDetails', { path: 'orderTemplateBindings', value });
}

export default {
	getTripTemplates,
	deleteTemplates,
	saveTripTemplate,
	fetchGeneratedTrips,
	setGeneratedTrips,
	setOrderTemplateBindings,
	...frequencySetters,
	...tripSetters,
	...legSetters,
};
